import {Component} from '@angular/core';
import {AiInsightTileComponent} from '../ai-insight-tile/ai-insight-tile.component';
import {CommonModule} from '@angular/common';
import {InventoryTileComponent} from '@components/medication/inventory-tile/inventory-tile.component';
import {CurrentScheduleTileComponent} from '@components/medication/current-schedule-tile/current-schedule-tile.component';
import {HistoryTileComponent} from '@components/medication/history-tile/history-tile.component';
import {TimelineTileComponent} from '@components/medication/timeline-tile/timeline-tile.component';

@Component({
    selector: 'app-insights-panel',
    standalone: true,
    imports: [
        AiInsightTileComponent,
        CommonModule,
        InventoryTileComponent,
        CurrentScheduleTileComponent,
        HistoryTileComponent,
        TimelineTileComponent
    ],
    templateUrl: './insights-panel.component.html',
    styleUrl: './insights-panel.component.scss'
})
export class InsightsPanelComponent {
    activeTab: string = 'current-schedule';

    tabs = [
        {id: 'current-schedule', label: 'Current Schedule'},
        {id: 'history', label: 'History'},
        {id: 'ai-insights', label: 'AI Insights'},
        {id: 'timeline', label: 'Timeline'}
    ];

    setActiveTab(tabId: string): void {
        this.activeTab = tabId;
    }

    isActiveTab(tabId: string): boolean {
        return this.activeTab === tabId;
    }
}
